class NyrTabbedCollections extends HTMLElement {
    constructor() {
        super()

        this.tabs = this.querySelectorAll('.js-tab')
        this.triggers = this.querySelectorAll('.js-trigger')
    }

    connectedCallback() {
        this.init()
    }

    hideTabs() {
        this.tabs.forEach(tab => tab.classList.remove('active'))
        this.triggers.forEach(trigger => trigger.classList.remove('active'))
    }

    showTab(index) {
        if (!index) return

        this.querySelector(`.js-tab[data-index="${index}"]`)?.classList.add('active')
        this.querySelector(`.js-trigger[data-index="${index}"]`)?.classList.add('active')
    }

    init() {
        this.triggers.forEach(trigger => {
            trigger.addEventListener('click', e => {
                if (trigger.classList.contains('active')) return

                this.hideTabs()

                this.showTab(trigger.getAttribute('data-index'))
            })
        })
    }
}
customElements.define('nyr-tabbed-collections', NyrTabbedCollections)